var _rect, _path, _path2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScotiaIconBank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 8,
    fill: "#EC111A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5257 12.0021L42.9164 12.0021L37.618 18.0328H29.2569C26.6726 18.0328 24.2184 18.4027 21.8734 20.3709C19.7167 22.181 18.6694 24.801 18.2963 26.8922C17.599 25.2104 15.7204 21.3553 18.6694 16.5558C21.6183 11.7562 24.6968 12.0021 27.5257 12.0021Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.393 43.9979L14.0023 43.9979L19.3007 37.9672H27.6618C30.2461 37.9672 32.7003 37.5973 35.0453 35.6291C37.202 33.819 38.2493 31.199 38.6224 29.1078C39.3197 30.7896 41.1983 34.6447 38.2493 39.4442C35.3004 44.2438 32.2219 43.9979 29.393 43.9979Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.4,
    cy: 28.0008,
    r: 7.9988,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScotiaIconBank);
export default __webpack_public_path__ + "static/media/scotia_icon_bank.345f68fc4ce6e263df129ae115cedfe1.svg";
export { ForwardRef as ReactComponent };